/** IS_DETAY (şablon string listesi) ve CI_DETAY (işlem maddesi + done) yardımcıları */

import { calcDeltaDays, computeRandevuOteleme, planMissedBeforeReorder } from './islemRandevuShift';

export function parseSablonDetayLabels(value) {
    if (value == null || value === '') return [];
    if (Array.isArray(value)) {
        return value
            .map((x) => (typeof x === 'string' ? x : (x?.ad ?? x?.label ?? '')))
            .map((s) => String(s).trim())
            .filter(Boolean);
    }
    if (typeof value === 'string') {
        const trimmed = value.trim();
        if (!trimmed) return [];
        try {
            const parsed = JSON.parse(trimmed);
            if (Array.isArray(parsed)) return parseSablonDetayLabels(parsed);
        } catch {
            /* virgülle ayrılmış metin */
        }
        return trimmed.split(',').map((s) => s.trim()).filter(Boolean);
    }
    return [];
}

export function serializeSablonDetayLabels(labels) {
    const list = parseSablonDetayLabels(labels);
    return list;
}

export function buildCiDetayFromSablon(isDetay, sablonAd = '') {
    const items = parseSablonDetayLabels(isDetay).map((ad) => ({ ad, done: false }));
    const name = String(sablonAd ?? '').trim();
    if (name) return { sablonAd: name, items };
    return items;
}

export function parseCiDetayWithMeta(value) {
    if (value == null || value === '') return { sablonAd: '', items: [] };
    let raw = value;
    if (typeof raw === 'string') {
        try {
            raw = JSON.parse(raw);
        } catch {
            return { sablonAd: '', items: [] };
        }
    }
    if (raw && typeof raw === 'object' && !Array.isArray(raw)) {
        const sablonAd = String(raw.sablonAd ?? raw.sablon_ad ?? '').trim();
        const items = parseCiDetay(Array.isArray(raw.items) ? raw.items : []);
        return { sablonAd, items };
    }
    return { sablonAd: '', items: parseCiDetay(raw) };
}

export function withCiDetayItems(value, items) {
    const { sablonAd } = parseCiDetayWithMeta(value);
    const nextItems = Array.isArray(items) ? items : [];
    if (sablonAd) return { sablonAd, items: nextItems };
    return nextItems;
}

export function parseCiDetay(value) {
    if (value == null || value === '') return [];
    let raw = value;
    if (typeof raw === 'string') {
        try {
            raw = JSON.parse(raw);
        } catch {
            return [];
        }
    }
    if (!Array.isArray(raw)) return [];
    return raw
        .map((item) => {
            if (typeof item === 'string') return { ad: item.trim(), done: false };
            const ad = String(item?.ad ?? item?.label ?? '').trim();
            if (!ad) return null;
            const doneVal = item?.done ?? item?.checked ?? item?.bool ?? false;
            const done = doneVal === true || doneVal === 1 || doneVal === '1' || String(doneVal).toLowerCase() === 't';
            return { ad, done };
        })
        .filter(Boolean);
}

export function formatSablonDetayPreview(value) {
    return parseSablonDetayLabels(value).join(', ');
}

export function hasCiDetayItems(value) {
    return parseCiDetayWithMeta(value).items.length > 0;
}

function toIsoDate(val) {
    if (val == null || val === '') return null;
    const d = val instanceof Date ? val : new Date(val);
    return isNaN(d.getTime()) ? null : d.toISOString();
}

/** Gerçekleşme işaretinde kaydedilecek güncellemeleri üretir (onay gerekirse needsConfirm). */
export function buildArrivalWithShiftUpdates(islemList, rowData, arrivalVal, options = {}) {
    const key = Number(rowData?.CI_REF ?? rowData?.ci_ref ?? 0);
    if (!key) return { updates: [], deltaDays: 0, needsConfirm: false, reorder: null };
    const casRef = options.casRef ?? rowData?.CI_CAS_REF ?? null;
    const arrivalIso = toIsoDate(arrivalVal);
    const deltaDays = rowData?.CI_RAN_TAR ? calcDeltaDays(arrivalVal, rowData.CI_RAN_TAR) : 0;
    const reorder = planMissedBeforeReorder(islemList, rowData, arrivalVal, {
        casRef,
        sablonLines: options.sablonLines,
    });
    if (reorder.active) {
        const updates = [
            { CI_REF: key, CI_ISL_TAR: arrivalIso, CI_RAN_TAR: toIsoDate(reorder.sourceRanTar) },
            ...reorder.updates.map((u) => ({
                CI_REF: u.CI_REF,
                CI_RAN_TAR: toIsoDate(u.CI_RAN_TAR),
            })),
        ].filter((u) => u.CI_REF > 0);
        return {
            updates,
            deltaDays,
            needsConfirm: true,
            reorder: {
                earlierMissedCount: reorder.earlierMissedCount,
                laterOpenCount: reorder.laterOpenCount,
            },
        };
    }
    if (!deltaDays) {
        return {
            updates: [{ CI_REF: key, CI_ISL_TAR: arrivalIso }],
            deltaDays: 0,
            needsConfirm: false,
            reorder: null,
        };
    }
    const { updates: shifted } = computeRandevuOteleme(islemList, rowData, deltaDays, { casRef });
    const updates = [
        { CI_REF: key, CI_ISL_TAR: arrivalIso },
        ...shifted.map((u) => ({
            CI_REF: u.CI_REF,
            CI_RAN_TAR: toIsoDate(u.CI_RAN_TAR),
        })),
    ].filter((u) => u.CI_REF > 0);
    return { updates, deltaDays, needsConfirm: true, reorder: null };
}

export function buildClearArrivalUpdates(rowData) {
    const key = Number(rowData?.CI_REF ?? rowData?.ci_ref ?? 0);
    if (!key) return [];
    const { items } = parseCiDetayWithMeta(rowData?.CI_DETAY);
    const nextDetay = withCiDetayItems(
        rowData?.CI_DETAY,
        items.map((item) => ({ ...item, done: false }))
    );
    const patch = { CI_REF: key, CI_ISL_TAR: null };
    if (items.length > 0) patch.CI_DETAY = nextDetay;
    return [patch];
}
